import { render } from "./RiskList.vue?vue&type=template&id=3ab64c0f"
import script from "./RiskList.vue?vue&type=script&lang=js"
export * from "./RiskList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__